import { useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import LevelDetailComponent from "./components/LevelDetailComponent";
import levelsAPI from "../../../services/levels";
import MeaPageTitle from "../../../components/MeaPageTitle";
import { useRef, useState } from "react";
import ClassesListComponent from "../classes/components/ClassesListComponent";
import CoursesListComponent from "../courses/components/CoursesListComponent";
import { TabMenu } from "primereact/tabmenu";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import UpdateLevelModal from "./components/UpdateLevelModal";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { PERMISSION_TRAINING_LEVELS } from "../../../permissions";
import DocumentsListComponent from "../documents/components/DocumentsListComponent";
import { useAuthContext } from "../../../hooks/useAuthContext";

const LevelDetailPage = () => {
  const { hasPermission } = useAuthContext();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const updateModalRef = useRef();
  const toast = useRef();
  const navigate = useNavigate();
  const levelId = params.levelId;
  //
  const levelQuery = levelsAPI.GetOne(
    schoolId,
    trainingId,
    accessToken,
    levelId
  );
  const levelObj = levelQuery?.data?.data;
  //
  // states
  const [activeTab, setActiveTab] = useState(0);
  const listRef = useRef();
  // params
  const tabs = [
    { label: "Classes", icon: "pi pi-th-large" },
    { label: "Matières", icon: "pi pi-file-edit" },
    //{ label: "Kits formateurs", icon: "pi pi-folder-open" },
  ];

  //
  return (
    <>
      <MeaPage
        showBackButton={true}
        title={<MeaPageTitle prefix={"Niveau:"} title={levelObj?.name} />}
        actions={[
          {
            label: "Modifier",
            icon: "pi pi-file-edit",
            disable: !hasPermission(PERMISSION_TRAINING_LEVELS.UPDATE),
            command: () => {
              if (updateModalRef.current) {
                updateModalRef.current.show(() => {
                  levelQuery.refetch();
                });
              }
            },
          },
          {
            separator: true,
            disable: !hasPermission(PERMISSION_TRAINING_LEVELS.UPDATE),
          },
          {
            label: "Supprimer",
            icon: "pi pi-trash",
            disable: !hasPermission(PERMISSION_TRAINING_LEVELS.DELETE),
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment supprimer ce niveau?",
                header: "Confirmation",
                icon: "pi pi-info-circle",
                defaultFocus: "reject",
                acceptClassName: "p-button-danger",
                accept: () => {
                  levelsAPI
                    .DeleteOne(schoolId, trainingId, accessToken, levelId)
                    .then((data) => {
                      toast.current.show({
                        severity: "success",
                        summary: "Succès",
                        detail: levelObj?.name + " Supprimé!",
                        life: 3000,
                      });
                      navigate(
                        "/school/" + schoolId + "/admin/trainings/" + trainingId + "/levels"
                      );
                    })
                    .catch((error) => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de suppression!",
                      });
                    });
                },
              });
            },
          },
        ]}
      >
        <LevelDetailComponent level={levelObj} />

        <UpdateLevelModal ref={updateModalRef} level={levelObj} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
        <ConfirmDialog />
        <Toast ref={toast} />

        <div className="mt-5">
          <TabMenu
            model={tabs}
            activeIndex={activeTab}
            onTabChange={(e) => {
              setActiveTab(e.index);
            }}
          />
          {activeTab === 0 && (
            <MeaLoadingContent objectQuery={levelQuery}>
              <ClassesListComponent
                ref={listRef}
                filter={{ level_id: levelObj?.id }}
                schoolId={schoolId}
                trainingId={trainingId}
                showAddButton={true}
                showFilterButton={false}
                showToolbar={true}
                selectedFields={{
                  level: false,
                  maxCapacity: true,
                }}
              />
            </MeaLoadingContent>
          )}
          {activeTab === 1 && (

            <MeaLoadingContent objectQuery={levelQuery}>
              <CoursesListComponent
                ref={listRef}
                filter={{ level_id: levelObj?.id }}
                showAddButton={true}
                showFilterButton={false}
                showToolbar={true}
                selectedFields={{
                  level: false,
                }}
              />
            </MeaLoadingContent>
          )}
          {activeTab === 2 && levelObj?.level_folder_id && (
            <MeaLoadingContent objectQuery={levelQuery}>
              <DocumentsListComponent
                ref={listRef}
                filter={{ parentId: levelObj?.level_folder_id || "" }}
                showAddButton={true}
                showFilterButton={false}
                showToolbar={true}
                selectedFields={{
                  level: false,
                }}
              />
            </MeaLoadingContent>
          )}
        </div>
      </MeaPage>
    </>
  );
};
export default LevelDetailPage;
